import { createContext, useContext } from 'react';
import { THEME_MODES } from '../theme';

const ThemeModeContext = createContext(null);

export const ThemeModeProvider = ({ value, children }) => (
  <ThemeModeContext.Provider value={value}>{children}</ThemeModeContext.Provider>
);

export const useThemeMode = () => {
  const context = useContext(ThemeModeContext);

  if (!context) {
    throw new Error('useThemeMode must be used within ThemeModeProvider');
  }

  return context;
};

export { THEME_MODES };
